import React from 'react';
import styles from './TipBoxTop.module.scss';

/* Providers */
import { useShopContext } from '../../../../shared/__providers__/ShopContext';

/* Components */
import { TipMatchForecastInfo } from '../MatchForecast/TipMatchForecastInfo';
import { BookieButton } from '../../../containers/TipComponents/BookieButton';

/* Types */
import {
  UnlockedMatchForecast,
  UnlockedTipData,
} from '../../../../../../store/tips/reducer';
import { TipProduct } from '../../../interfaces/TipProduct';
import { CredentialsUserObject } from '../../../../../../types/Login';

/* Redux */
import { RootState } from '../../../../../../store';
import { userSelector } from '../../../../../../store/tipster/selector';
import { connect } from 'react-redux';

interface TipBoxTopProps {}
interface ReduxProps {
  user: CredentialsUserObject;
}
export const UnlockedTipBoxTop: React.FC<TipBoxTopProps & ReduxProps> = ({
  user,
}) => {
  const { shop } = useShopContext();
  const tip = shop!.selectedProduct as TipProduct;

  return (
    <>
      {tip && (
        <div className={styles.innerTopBox}>
          <div className={styles.unlocked}>
            {!!(tip.tip as UnlockedTipData).match_forecasts &&
              (tip.tip as UnlockedTipData).match_forecasts.map(
                (forecast: UnlockedMatchForecast) => (
                  <TipMatchForecastInfo forecast={forecast} key={forecast.id} />
                ),
              )}
          </div>
        </div>
      )}
      <BookieButton tip={tip} isTipster={user ? user.is_tipster : false} />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: userSelector(state),
});

export const UnlockedTipBoxTopConnected =
  connect(mapStateToProps)(UnlockedTipBoxTop);
